import { render, staticRenderFns } from "./secondDelete.vue?vue&type=template&id=971a11c6&scoped=true&"
import script from "./secondDelete.vue?vue&type=script&lang=js&"
export * from "./secondDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971a11c6",
  null
  
)

export default component.exports